export const CLAIMS_LOCAL_STORAGE_KEY = "claims";
export const ACCESS_TOKEN_STORAGE_KEY = "access_token";
export const EXPIRES_AT_LOCAL_STORAGE_KEY = "expires_at";
export const PROFILE_LOCAL_STORAGE_KEY = "profile";
export const OKTA_GROUPS_LOCAL_STORAGE_KEY = "oktaGroups";
export const SPOG_TOGGLE_LOCAL_STORAGE_KEY = "spogToggleValue";

// sessionStorage keys
export const POST_LOGIN_REDIRECT_SESSION_KEY = "post_login_redirect";
export const ADMIN_CONTEXT_ORG_ID_SESSION_KEY = "admin_context_org_id";
